import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { useStyles } from './styles'

const TooltipCustom = ({ children, title, open, setOpen }) => {
  const classes = useStyles()

  const handleTooltipClose = () => setOpen(false)

  return (
    <ClickAwayListener>
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={open}
        classes={{
          tooltip: classes.customTooltip,
          arrow: classes.customArrow,
        }}
        title={<span className={classes.titileTooltip}>Keep it up to 62 symbols</span>}
        placement='right'
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  )
}

export default TooltipCustom
